module.exports = __webpack_public_path__ + "img/GH-kyujin-work-illustration001.a381e5a0.webp";